import { useContext } from 'react'

import { behaviorNames, scopeNames } from '../../../../../main/blacklistHelpers'
import BlacklistContext from '../../BlackListContext'
import DetailsColumn from '../../DetailsColumn'
import styles from './BehaviorAndScope.module.scss'

const BehaviorAndScope = () => {
  const { conversion, lengths, setScope, setBehavior, exclusions } =
    useContext(BlacklistContext)

  return (
    <>
      {exclusions.map(({ requestCategory, behavior, scope }) => (
        <DetailsColumn
          key={requestCategory}
          name={requestCategory}
          conversion={conversion}
          lengths={lengths}
        >
          <BehaviorDrowndown
            name={requestCategory}
            handleChange={val => setBehavior(requestCategory, val)}
            value={behavior}
          />
          <ScopeDrowndown
            name={requestCategory}
            handleChange={val => setScope(requestCategory, val)}
            value={scope}
          />
        </DetailsColumn>
      ))}
    </>
  )
}

const BehaviorDrowndown = ({ handleChange, name, value = 'none' }) => {
  let behaviors = behaviorNames

  if (name === 'convertedAddress' || name === 'invitedAddress') {
    delete behaviors.noReach
  }

  return (
    <select
      value={value || 'none'}
      className={styles.dropdown}
      onChange={e => handleChange(e.target.value)}
    >
      <option value="none" disabled>
        Select a behavior
      </option>
      {Object.keys(behaviors).map(k => (
        <option key={name + k} value={k}>
          {behaviors[k]}
        </option>
      ))}
    </select>
  )
}

const ScopeDrowndown = ({ handleChange, name, value = 'none' }) => (
  <select
    value={value || 'none'}
    className={styles.dropdown}
    onChange={e => handleChange(e.target.value)}
  >
    <option value="none" disabled>
      Select a scope
    </option>
    {Object.keys(scopeNames).map(k => (
      <option key={name + k} value={k}>
        {scopeNames[k]}
      </option>
    ))}
  </select>
)

export default BehaviorAndScope
